import React, { useEffect, useRef, useState } from 'react';

import {Form, Input, Row, Col, Select} from 'antd';
import {InputCpfCnpj} from '../campos/cpfCnpj/input-cpf-cnpj';
import NumberFormat from 'react-number-format';
import { InputCEP } from '../campos/cep/input-cep';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSpinnerThird} from '@fortawesome/pro-solid-svg-icons';
// import axios from 'axios';


const useFieldFormat = () => {
    const formataTelefone = (val) => {
        let format = "";
        if(val.length >= 11){
            format = val.replace(/(\d{2})(\d)/, '($1) $2')
                        .replace(/(\s\d{1})(\d)/, ' $1 $2')
                        .replace(/(\d{4})(\d)/, '$1-$2')  
                        .replace(/(-\d{4})\d+?$/, '$1')                      
        } else if(val.length == 9){
            format = val.replace(/(\d{1})(\d)/, '$1 $2')
                    .replace(/(\d{4})(\d)/, '$1-$2')                        
        }                    
        else if(val.length === 8){
            format = val.replace(/(\d{4})(\d{4})/, '$1-$2');
                    
        } else if(val.length === 10){
            format = val.replace(/(\d{2})(\d)/, '($1) $2')
                        .replace(/(\s\d{4})(\d)/, '$1-$2')
                    
                    
            
        }

        if(!format){
            return val;
        }

        return format;
    }

    const formataCep = (val) => {
        let format = "";
        if(val.length >= 8){
            format = val.replace(/(\d{2})(\d)/, '$1.$2')
                .replace(/(\d{3})(\d)/, '$1-$2')
                .replace(/(-\d{3})\d+?$/, '$1')       
        }

        if(!format){
            return val;
        }

        return format;
    }

    return {formataTelefone, formataCep};
}


// const useViaCep = () => {

//     const buscaCep = async (cep) => {
        
//         const ax = axios.create();
//         return ax.get('https://viacep.com.br/ws/'+cep+'/json/');
//     }

//     return {buscaCep};
// }


const Ie = (props) => {
    
    if(props.tipoDocumento === "CPF"){
        return (<div></div>);
    } 
    return <Form.Item
                label="IE"
                name="ie" 
            >
                <Input />
            </Form.Item>


}


const NomeFantasia = (props) => {
    
    if(props.tipoDocumento === "CPF"){
        return (<div></div>);
    } 
    return <Form.Item
                label="Nome Fantasia"
                name="nomeFantasia" 
            >
                <Input />
            </Form.Item>


}

const Telefone = props => {

    const {formataTelefone} = useFieldFormat();

    const onChange = (values) => {
        props.onChange && props.onChange(values.value);
    }

    return <NumberFormat format={formataTelefone} customInput={Input} onValueChange={onChange}></NumberFormat>;
}


const Nome = props => {
    if(props.tipoDocumento == "CPF"){
        return  <Form.Item
                    label="Nome"
                    name="nome" 
                >
                    <Input />
                </Form.Item>;
    } 
    return  <Form.Item
                label="Razão Social"
                name="nome" 
            >
                <Input />
            </Form.Item>;


}

const usePessoa  = (getApi) => {


    const salvarPessoa = async (form) => {
        const api = await getApi();
        
        const pessoa = preparaPessoaParaSalvar(form.getFieldsValue(true))
        
        const promiseSave = api.post("/pessoas", pessoa);
        return {promiseSave, pessoa};


    }

    const buscaVendedoresParaVincularAoCliente = async () => {
        const api = await getApi();
        
        const sugestoes = await api.get("/pessoas/sugestoes/vendedores");
        return sugestoes.data;
    }

    const preparaPessoaParaSalvar = (dados) => {
        console.log(dados);
        let dadosPreparados = Object.assign({}, dados);
        
        if(dados.cidade){
            dadosPreparados = Object.assign({}, dadosPreparados, {
                cidade: {
                    cod_cidade_ibge: dados.cod_cidade_ibge,
                    estado_uf: dados.estado, 
                    cidade:dados.cidade
                }, 
                estado: {
                    cod_estado_ibge: dados.cod_estado_ibge,
                    estado: dados.estado,
                    uf: dados.estado
                }               
            })
        }

        dadosPreparados.documento = {};
        if(dados.cpfCnpj){
            dadosPreparados.documento.cpfCnpj = dados.cpfCnpj;
        }
        
        if(dados.ie){
            dadosPreparados.documento.ie = dados.ie.replace(/\D/g, '');
        }

        dadosPreparados.tipoPessoa = JSON.stringify(dados.tipoPessoa)
        return dadosPreparados;
    }

    return {salvarPessoa, buscaVendedoresParaVincularAoCliente }
}


const FormularioPessoas = ({registraSalvarFunc, getApi, tipoPessoa="CLIENTE", onAfterSave = undefined}) => {
    const [cpfCnpjValido, setCpfCnpjValido] = useState('success');
    
    const [tipoDocumento, setTipoDocumento] = useState('CPF');
    const [cepValido, setCepValido] = useState(true);

    const {salvarPessoa} = usePessoa(getApi);

    const [form] = Form.useForm();
    const [loadingCEP, setLoadingCep] = useState(false);
    

    let numeroInput = useRef(null);

    useEffect(()=> {
        form.setFieldsValue({
            tipoPessoa: []
        });

        form.getFieldValue('tipoPessoa').push((tipoPessoa || "CLIENTE"))
    },[])


    

    const salvarFunc = async () => {
        const {promiseSave, pessoa} = await salvarPessoa(form);
        const {data: pessoaSalva } = await promiseSave;
        
        if(pessoaSalva.uuid){
            onAfterSave(pessoaSalva);
        } else {
            onAfterSave(pessoa);
        }
    }

    useEffect(() => {
        console.log("registrando")
        registraSalvarFunc(salvarFunc);
        console.log("fim")
    }, [])


    const onChangeCep =async (evt) => {
        const {cep, ...endereco} = evt;
        form.setFieldsValue(endereco);
        form.setFieldsValue({ cep });
        
        if(endereco.cidade.length){
            numeroInput.current.focus();
        }
       
    }
    

    return (<Form layout="vertical" form={form} >
            
            <Input.Group>
                <Row gutter={8}>
                    <Col xl={8} md={24}>
                        <Form.Item
                            label="CPF/CNPJ"
                            name="cpfCnpj"
                            validateTrigger={["onBlur"]}
                            hasFeedback
                           
                            rules={[
                                ({ getFieldValue }) => ({
                                    validator(_, value){
                                        if(cpfCnpjValido){
                                            return Promise.resolve();
                                        }                                        
                                        return Promise.reject(new Error("O CPF ou CNPJ é inválido"));
                                    }
                                })
                            ]}
                            
                        >
                            
                                <InputCpfCnpj setCpfCnpjValido={({valido, tipo})=> {
                                    setCpfCnpjValido(valido);
                                    setTipoDocumento(tipo);
                                }}  />                
                        </Form.Item>
                    </Col>
                
                    <Col xl={16} md={24}>


                       <Nome tipoDocumento={tipoDocumento}></Nome>
                    </Col>


                </Row>
            </Input.Group>

            <NomeFantasia tipoDocumento={tipoDocumento}></NomeFantasia>

            <Ie tipoDocumento={tipoDocumento}></Ie>

            <Input.Group>
                <Row gutter={8}>
                        <Col xl={12} md={24}>
                            <Form.Item
                                label="E-mail"
                                name="email" 
                            >
                                <Input />
                        </Form.Item>
                        </Col>
                        <Col xl={6} md={24}>
                            <Form.Item
                                label="Telefone"
                                name="telefone" 
                            >
                                <Telefone></Telefone>
                            </Form.Item>
                                    
                        </Col>
                        <Col xl={6} md={24}>
                                
                            <Form.Item
                                label="Celular"
                                name="celular" 
                            >
                                <Telefone></Telefone>
                            </Form.Item>
                        </Col>
                        
                </Row>
            </Input.Group>


          

            <Input.Group>
                <Row gutter={8}>
                        <Col xl={8} md={24}>
                        <Form.Item
                            label={<span>CEP&nbsp;
                                {(()=>{
                                    if(loadingCEP){
                                        return <FontAwesomeIcon icon={faSpinnerThird} spin />
                                    }
                                })()
                            }
                            </span>}
                            name="cepField" 
                            validateTrigger={["onChange"]}
                            loading={true}
                            
                            rules={[
                                { 
                                    // valid : ({ getFieldValue }) => {
                                    //     console.log(getFieldValue);
                                        
                                    validator(_, value){
                                        if(cepValido){
                                            return Promise.resolve();
                                        }else {
                                            return Promise.reject(new Error("CEP nao encontrado"));
                                        }                                        
                                    },
                                //    },
                                   message: <span>O CEP é inválido ou não existe mais. Consulte em: <a href='https://buscacepinter.correios.com.br/app/endereco/index.php' target='_blank'>Site dos Correios</a></span>
                                }
                            ]}
                            
                        >   
                            <InputCEP loading={setLoadingCep} onChange={onChangeCep} setCepValido={setCepValido} ></InputCEP>
                            {/* <NumberFormat onValueChange={onChangeCep} format={formataCep} customInput={Input}></NumberFormat> */}
                            
                        </Form.Item>
                        </Col>
                        <Col xl={16} md={24}>
                            <Form.Item
                                label="Endereço"
                                name="endereco" >                
                                    <Input />   
                            </Form.Item>
                        </Col>
                </Row>
            </Input.Group>



            <Input.Group>
                <Row gutter={8}>
                        <Col xl={8} md={24}>
                            <Form.Item
                                label="Número"
                                name="numero" 
                              
                            >
                                <Input 
                                      ref={numeroInput}
                                />
                            </Form.Item>
                        </Col>
                        <Col xl={16} md={24}>
                            <Form.Item
                                label="Bairro"
                                name="bairro" 
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                </Row>
            </Input.Group>

                


          

            <Form.Item
                label="Complemento"
                name="complemento" 
            >
                <Input />
            </Form.Item>


            <Input.Group compact>
            
                <Form.Item
                    style={{
                        width: "calc(50% - 5px)",
                        marginRight: "5px"
                    }}
                    label="Cidade"
                    name="cidade" 
                    help="Preencha o CEP para preencher a cidade e estado"
                    
                >
                    <Input  disabled={true}/>
                </Form.Item>

                <Form.Item
                    style={{
                        width: "calc(50% - 5px)",
                        marginLeft: "5px"
                    }}
                    label="Estado"
                    name="estado" 
                    
                >
                    <Input disabled={true}/>
                </Form.Item>

            </Input.Group>

            <VendedorVinculado form={form} tipoPessoa={tipoPessoa} getApi={getApi}></VendedorVinculado>

            <Form.Item
                label="Observações"
                name="obs" 
            >
                <Input.TextArea />
            </Form.Item>
        </Form>);
};


const SelectVendedorVinculado = ({getApi, form, onChange}) => {
    const noneValue = {
        label: "Nenhum vendedor vinculado",
        value: ""
    };
    const [vendedores, setVendedores] = useState([noneValue]);

    const [loading, setLoading] = useState(false);

    const {buscaVendedoresParaVincularAoCliente} = usePessoa(getApi);

    const carregaListaVendedores = async () => {
        setLoading(true);
        try{
            
            const vendedores = await buscaVendedoresParaVincularAoCliente();
            
            setVendedores([noneValue].concat(vendedores.map(vendedor => ({
                label: vendedor.nome,
                value: vendedor.email
            }))));
        } catch(err){
            console.log(err);
        } finally{
            setLoading(false);
        }
    }
   
    useEffect(() => {

        carregaListaVendedores();
    }, [true])


    const onChangeHandler = (value) => {
        console.log(value,"value")
        form.setFieldsValue({
            vendedorVinculado: value
        });
        onChange && onChange(value);
    }
 
    return <Select   
        loading={loading}
         onChange={onChangeHandler}
         defaultValue=""
            options={vendedores}
    ></Select> 
}


const VendedorVinculadoShow = ({form, getApi}) => {
    


    return <Form.Item
                label="Vendedor Vinculado"
                name="vendedorVinculado" 
            >
        <SelectVendedorVinculado getApi={getApi} form={form}></SelectVendedorVinculado>            
    </Form.Item>
}
const VendedorVinculado = ({getApi, form, tipoPessoa}) => {
    
    if(tipoPessoa == "CLIENTE"){
        return <VendedorVinculadoShow getApi={getApi} form={form} ></VendedorVinculadoShow>
    }
    return <></>;
}

export { FormularioPessoas };